<form [formGroup]="form">
    <div class="card-inline full-width">
        <div style="overflow-y: scroll;overflow-x:scroll;max-height:250px;">
            <table class="search-table" mat-table [dataSource]="documentationItemsDataSource" formArrayName="DocumentationItems">
                <ng-container matColumnDef="name">
                    <th class="search-table-header resizable-column" mat-header-cell #resThFecha *matHeaderCellDef>
                        <resizable-column-control width="300" tile="Nombre" #resColFecha></resizable-column-control>
                    </th>
                    <td class="search-table-cell" mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
                        <div><b>{{displayName(index)}}</b></div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="description">
                    <th mat-header-cell class="table-header" *matHeaderCellDef> Descrìpción </th>
                    <td class="search-table-cell" mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
                        <div>{{displayDescription(index)}}</div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="carryPatient">
                    <th mat-header-cell class="table-header" *matHeaderCellDef> Trajo paciente </th>
                    <td class="search-table-cell" mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
                        <div>
                            <mat-checkbox formControlName="CarryPatient"></mat-checkbox>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="info">
                    <th class="search-table-header" mat-header-cell *matHeaderCellDef></th>
                    <td class="search-table-cell" mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
                        <div>
                            <mat-form-field class="full-width">
                                <input placeholder="Valor" matInput formControlName="Info">
                            </mat-form-field>
                        </div>
                    </td>
                </ng-container>

                <!-- Star Column -->
                <ng-container matColumnDef="star" stickyEnd>
                    <th class="search-table-header" style="width:1px;" mat-header-cell *matHeaderCellDef></th>
                    <td class="search-table-cell" style="width:1px;" mat-cell *matCellDef="let element"></td>
                </ng-container>
                <tr mat-header-row class="search-table-header" *matHeaderRowDef="displayDocumentationItemsColumns; sticky: true"></tr>
                <tr mat-row class="search-table-cell" *matRowDef="let row; columns: displayDocumentationItemsColumns;"></tr>
            </table>
        </div>
    </div>
</form>
